










import { isAndroid } from '@/utils/env';
import {
    defineComponent,
    watch,
    ref,
    onMounted,
    onUnmounted,
    computed,
} from '@vue/composition-api';
import HomeModel from '@/views/Home/model/index';
import { useApolloModel } from 'vue-apollo-model';
import { useLog } from '@/logger';
import { getServerExpTag } from '@/utils/exptag';
import yoda from '@/yoda';

export default defineComponent({
    name: 'PV',
    components: {},
    props: {
        tlBtn: { type: Boolean, default: false },
        icon: { type: String, default: 'back' },
        /**
         * pv page
         */
        name: String, // 可以不传，会默认使用route.meta.pv || location.href
        /**
         * pv 参数
         */
        params: {
            type: Object,
            default: () => ({}),
        },
        /**
         * 参数是否异步获取
         */
        async: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, context) {
        const params = computed(() => props.params);
        const model = useApolloModel(HomeModel);
        const log = useLog();
        const report = async type => {
            const exptag = await getServerExpTag();
            log(
                {
                    isPV: true,
                    immediate: type !== 'enter', // enter使用collect，其他采用立即收集
                    params: {
                        exptag,
                        ...context.root.$route.query,
                        ...params.value,
                    },
                    type,
                    page: props.name || context.root.$route.meta.pv || location.href,
                },
                'show',
            );
        };
        const handleVisibilityChange = () => {
            report(document.visibilityState);
        };

        if (props.tlBtn) {
            yoda('kwai', 'setTopLeftBtn', {
                show: true,
                icon: props.icon,
                onClick() {
                    report('leave');
                    context.emit('click');
                    if (/\/detail\/\d+/.test(location.pathname)) {
                        context.root.$close();
                    }
                },
            });
            if (isAndroid && !/\/detail\/\d+/.test(location.pathname)) {
                yoda('kwai', 'setPhysicalBackButton', {
                    onClick() {
                        report('leave');
                        context.emit('click');
                    },
                });
            }
        }
        // 异步参数
        watch(
            () => props.params,
            () => {
                // 利用JSON.stringify会忽略值为undefined的特性（只能做到少上报几次  并不能完全做到只报一次）
                const isEmpty = JSON.stringify(props.params) === '{}';
                if (props.async && !isEmpty) {
                    // params.value = props.params;
                    // 触发loaded
                    report('enter');
                }
            },
            {
                deep: true,
            },
        );
        onMounted(() => {
            if (!props.async) {
                report('enter');
            }
            document.addEventListener('visibilitychange', handleVisibilityChange);
        });
        onUnmounted(() => {
            report('leave');
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        });
        return {};
    },
});
